import { useEffect, useRef, useState } from 'react';

type UseAsyncMemoOptions<T> = {
	initialValue?: T;
	clearOnChange?: boolean;
};

export default function useAsyncMemo<T>(factory: () => Promise<T>, deps: React.DependencyList, options?: UseAsyncMemoOptions<T>): T | undefined {
	const { initialValue, clearOnChange = true } = options ?? {};
	const [result, setResult] = useState<T | undefined>(initialValue);
	const requestIdRef = useRef(0);

	useEffect(() => {
		let cancelled = false;
		const requestId = requestIdRef.current + 1;
		requestIdRef.current = requestId;

		if (clearOnChange) {
			setResult(initialValue);
		}

		factory().then((value) => {
			if (!cancelled && requestIdRef.current === requestId) {
				setResult(value);
			}
		});

		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);

	return result;
}
